'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueFroala = require('./vue-froala');

var _vueFroala2 = _interopRequireDefault(_vueFroala);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vueFroala2.default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-froala-wysiwyg/es/index.js
// module id = 9fd9
// module chunks = 0